import type { GridCell } from '@glideapps/glide-data-grid';
import { isTickerCell } from '../../CustomCell/Ticker';
import type { TickerCell } from '../../CustomCell/Ticker/types';

export const findMatchingTickerCellRows = (
  tickerCell: TickerCell,
  tickerColumn: GridCell[] = []
): number[] => {
  const { uniqueSymbol, value, status } = tickerCell.data;

  return tickerColumn.reduce((matchRows: number[], cell, rowIndex) => {
    if (isTickerCell(cell)) {
      const isSuccessMatch =
        status === 'success' && cell.data.uniqueSymbol === uniqueSymbol;
      const isErrorMatch = status === 'error' && cell.data.value === value;

      if (isSuccessMatch || isErrorMatch) {
        matchRows.push(rowIndex);
      }
    }
    return matchRows;
  }, []);
};
